import Http from "./index";

const http = new Http("api/");

export default {

  async userLogin(data) {
    const res = await http.post("login/user", data);
    return res.data;
  },

  async imeiLogin(data) {
    const res = await http.post("login/imei", data);
    return res.data;
  },

  async groupLogin(data) {
    const res = await http.post("login/group", data);
    return res.data;
  },


  async sendCode(data) {
    const res = await http.post("user/code", data);
    return res.data;
  },

  async register(data) {
    const res = await http.post("user/register", data);
    return res.data;
  },


  async resetUserPassword(data) {
    const res = await http.patch("password/reset", data);
    return res.data;
  },

  async changeUserPassword(data) {
    const res = await http.patch("password", data);
    return res.data;
  },

  async userInfo() {
    const res = await http.get("user/info");
    return res.data;
  },

  async getUserSetting() {
    const res = await http.get("user/setting");
    return res.data;
  },



  async updateUserSetting(data) {
    const res = await http.put("user/setting", data);
    return res.data;
  },
};
